import React, { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import BtnSelect from '../../../Shared/Buttons/BtnSelect';
import BtnPink from '../../../Shared/Buttons/BtnPink';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { setCurrentStep, saveToHistory } from '../IdfSaleSlice';
import { getPreviousPage, getCurrentHistory } from '../IdfSaleEnums';
import { prepareSameWindowUrlWithNavigateTo } from 'app/utilities/StringHelpers/StringHelpers';
import Config from 'app/Config';

function Buttons({
  onClickNavigation,
  backPage,
  continuePage,
  isForm,
  setIsSubmit,
  canContinue,
  hideBackButton,
  btnContinueText,
  setCurrentStep,
  saveToHistory,
  store
}) {

  let enumValues = getCurrentHistory(store);
  const currentIndex = enumValues.indexOf(store.steps.current);
  let nextStep = (currentIndex < enumValues.length - 1 ? enumValues[currentIndex + 1] : store.steps.current);

  const goToNextPage = async () => {
    var response = true;
    if (onClickNavigation != null) {
      response = await onClickNavigation();
    }
    if (canContinue && response) {
      saveToHistory(store.steps.current);
      setCurrentStep({ current: nextStep, previous: store.steps.current });
    }
  }

  const goBack = async () => {
    setCurrentStep({ current: store.steps.previous, previous: getPreviousPage(store, Config) })
  }

  return (
    <Container fluid className='idf-sale-buttons-container'>
      <BtnPink
        text={btnContinueText ? btnContinueText : 'אישור והמשך'}
        disabled={canContinue ? false : true}
        onclick={async () => {
          isForm ? await setIsSubmit(true) : goToNextPage();
        }}
      />
      {!isMobile && !hideBackButton && <BtnSelect text={'חזרה למסך הקודם'} onClick={() => goBack()} />}
    </Container>
  );
}
const mapStateToProps = (state) => ({
  store: state.idfSale,
});

const mapDispatchToProps = {
  setCurrentStep,
  saveToHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(Buttons);
